import { ReactNode } from "react";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import BackArrowIcon from "../../img/icons/arrow-left.svg?react";
import CloseIcon from "../../img/icons/cross.svg?react";
import { HeadingFontSize } from "../../types";
import { IconButton } from "../buttons/IconButton";
import {
  actionBarStyles,
  closeButtonWrapper,
  headerSectionStyles,
  headingStyles,
} from "./sheet.css";

interface SheetHeaderProps {
  fontSize: HeadingFontSize;
  handleClose: () => void;
  handleBack?: () => void;
  isDismissable?: boolean;
  title?: ReactNode;
}

const SheetHeader = ({
  title,
  fontSize,
  handleClose,
  handleBack,
  isDismissable,
}: SheetHeaderProps) => {
  const { back, closeButton } = usePlosTranslations();

  return (
    <div className={headerSectionStyles}>
      <div className={actionBarStyles}>
        {handleBack && (
          <IconButton
            onPress={handleBack}
            icon={<BackArrowIcon />}
            label={back}
            appearance="text"
          />
        )}

        <div className={closeButtonWrapper}>
          {isDismissable && (
            <IconButton
              onPress={handleClose}
              icon={<CloseIcon />}
              label={closeButton}
              appearance="text"
            />
          )}
        </div>
      </div>
      {title && (
        <h1 id="sheet-title" className={headingStyles({ size: fontSize })}>
          {title}
        </h1>
      )}
    </div>
  );
};

export default SheetHeader;
